// @core/api/endpoints/project/list_components.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListComponentsResponse,
} from '../../../types/project';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/project';

/**
 * List components
 * Returns all components defined for the project.
 */
export async function ListComponents(
  project_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListComponentsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/components`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.get<ListComponentsResponse>(requestPath, { ...requestOptions, params });
}
